import { Component, Input, OnInit, Optional, Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { NotificationSaleAdminModel, NotificationSaleAdmin, NotificationSaleAdminTabs } from 'src/app/models/notifications/notification-sale-admin.model';
import { NotificationTypes } from 'src/app/models/notifications/notification.model';
import { NotificationsService } from 'src/app/services/notifications.service';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(value: any) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
@Component({
  selector: 'sale-admin-notification-setting-popup',
  templateUrl: './sale-admin-notification-setting-popup.component.html',
  styleUrls: ['./sale-admin-notification-setting-popup.component.scss']
})
export class SaleAdminNotificationSettingPopupComponent extends BaseUnsubscribeComponent implements OnInit {

  @Input() public data: any;
  public isLoading: boolean = false;
  public isSubmitLoading: boolean = false;

  public notificationTypes: NotificationTypes[];
  public allNotificationTypes: NotificationTypes[];
  public notificationForm: FormGroup;

  public notificationSaleAdminRecords: NotificationSaleAdmin[];
  public notificationSaleAdminTabs = NotificationSaleAdminTabs;

  private NotificationSaleAdminModel: NotificationSaleAdminModel = new NotificationSaleAdminModel();

  public tab = this.notificationSaleAdminTabs.LIST;
  public selectedNotificationId = 0;
  public tagLegendTable: string;
  constructor(
    private modalService: NgbModal,
    public readonly notificationsService: NotificationsService,
    private readonly fb: FormBuilder,
    private toastService: ToastService,
    @Optional() private activeModal?: NgbActiveModal
  ) {
    super();
  }

  private saveNotificationTemplate(): void {
    this.notificationsService.postSaleAdminNotification(this.NotificationSaleAdminModel).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {

      if (response) {
       // this.getNotificationSaleAdminRecords();
       
       // this.tab = this.notificationSaleAdminTabs.LIST;
        this.isSubmitLoading = false;
        this.toastService.success('Notifications updated successfully');
        this.closePopup();
      }
    });

  }

  public submit(): void {

    if (this.notificationForm.valid && this.tab == this.notificationSaleAdminTabs.ADD) {

      const formData = this.notificationForm.value;

      this.isSubmitLoading = true;
      this.notificationTypes = this.allNotificationTypes;
      this.NotificationSaleAdminModel.emailSubject = formData.emailSubject;
      this.NotificationSaleAdminModel.emailBody = formData.emailBody;
      this.NotificationSaleAdminModel.smsMessage = formData.smsText;
      this.NotificationSaleAdminModel.notificationTypeId = Number(this.selectedNotificationId);

      if (formData.notificationMethods.email && formData.notificationMethods.sms) {
        this.NotificationSaleAdminModel.isEmail = true;
        this.NotificationSaleAdminModel.isSMS = true;
        this.saveNotificationTemplate();
        return;
      }

      else if (formData.notificationMethods.email) {

        this.NotificationSaleAdminModel.isEmail = true;
        this.NotificationSaleAdminModel.isSMS = false;
        this.saveNotificationTemplate();
        return;
      }

      if (formData.notificationMethods.sms) {

        this.NotificationSaleAdminModel.isEmail = false;
        this.NotificationSaleAdminModel.isSMS = true;
        this.saveNotificationTemplate();
        return;
      }
    }
  }

  public closePopup(): void {
    this.activeModal?.close(JSON.stringify(this.data));
  }

  public initiateForm(): void {
    this.notificationForm = this.fb.group({
      notificationType: ["", Validators.required],
      notificationMethods: this.fb.group({
        email: [false],
        sms: [false],
      }),
      emailSubject: [{ value: '', disabled: true }],
      emailBody: [{ value: '', disabled: true }],
      smsText: [{ value: '', disabled: true }],
    });
  }

  public onCheckboxChange(checkboxName: string): void {
    const checkbox = this.notificationForm.get(`notificationMethods.${checkboxName}`);
    const emailSubject = this.notificationForm.get('emailSubject');
    const emailBody = this.notificationForm.get('emailBody');
    const smsText = this.notificationForm.get('smsText');

    if (checkbox && emailSubject && emailBody && smsText) {
      if (checkboxName === 'email') {
        if (checkbox.value) {
          emailSubject.enable();
          emailBody.enable();
        } else {
          emailSubject.disable();
          emailBody.disable();
        }
        this.updateValidators(emailSubject, checkbox.value);
        this.updateValidators(emailBody, checkbox.value);
      } else if (checkboxName === 'sms') {
        if (checkbox.value) {
          smsText.enable();
        } else {
          smsText.disable();
        }
        this.updateValidators(smsText, checkbox.value);
      }
    }
  }

  private updateValidators(control: AbstractControl, condition: boolean): void {
    if (condition) {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
    }

    control.updateValueAndValidity();
  }

  public validateSubmitButton(): boolean {

    if (this.notificationForm.invalid) {
      return true;
    }

    if (!this.notificationForm.get('notificationMethods.email').value && !this.notificationForm.get('notificationMethods.sms').value) {
      return true;
    }

    if (this.isSubmitLoading) {
      return true;
    }

    return false;
  }

  public getNotificationName(notificationId: number): object {
    if (this.notificationTypes?.length > 0) {
      const notification = this.notificationTypes.find(n => n.notificationTypeId === notificationId);
      if (notification) {
        return notification;
      }
    }

    return null;
  }

  public addNotification() {
    const modalRef = this.modalService.open(SaleAdminNotificationSettingPopupComponent, {
      size: '75-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.data = { tab: this.notificationSaleAdminTabs.ADD };
    modalRef.result.then(
      (result) => {
        this.getNotificationSaleAdminRecords();
        //this.activityEnd.emit(Activity.XRayView);
      },
      (reason) => {
        //this.activityEnd.emit(Activity.XRayView);
      }
    );
  }

  public editNotification(notificationSaleAdminRow: NotificationSaleAdmin) {
    const modalRef = this.modalService.open(SaleAdminNotificationSettingPopupComponent, {
      size: '75-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.data = { tab: this.notificationSaleAdminTabs.ADD, notificationSaleAdminRow: notificationSaleAdminRow };
    modalRef.result.then(
      (result) => {
        this.getNotificationSaleAdminRecords();
        //this.activityEnd.emit(Activity.XRayView);
      },
      (reason) => {
        //this.activityEnd.emit(Activity.XRayView);
      }
    );
  
  }

  public onChangeView(key: NotificationSaleAdminTabs, notificationSaleAdminRow: NotificationSaleAdmin = null): void {
    this.tab = key;
    this.notificationTypes = this.allNotificationTypes;
    this.selectedNotificationId = 0;

    const emailSubject = this.notificationForm.get('emailSubject');
    const emailBody = this.notificationForm.get('emailBody');
    const smsText = this.notificationForm.get('smsText');

    this.notificationForm.markAsPristine();
    this.notificationForm.markAsUntouched();


    if (notificationSaleAdminRow) {

      const updatedNotificationMethods = {
        email: notificationSaleAdminRow.isEmail,
        sms: notificationSaleAdminRow.isSMS,
      };



      this.selectedNotificationId = notificationSaleAdminRow.notificationTypeId;
      let patchedForm = {
        notificationType: this.selectedNotificationId,
        emailSubject: notificationSaleAdminRow.emailSubject,
        emailBody: notificationSaleAdminRow.emailBody,
        smsText: notificationSaleAdminRow.smsMessage,
        notificationMethods: updatedNotificationMethods
      };

      this.notificationForm.patchValue(patchedForm);
      this.onNotificationTypeChange(null);
      if (this.selectedNotificationId > 0) {
        const notificationType = this.notificationForm.get('notificationType');
        notificationType.disable();
      }
      this.onCheckboxChange("email");
      this.onCheckboxChange("sms");      

      return;
    }
    if (this.tab === this.notificationSaleAdminTabs.ADD) {      
      this.notificationTypes = this.notificationTypes.filter(type => {
        const existingNotification = this.notificationSaleAdminRecords.find(n => n.notificationTypeId === type.notificationTypeId);
        return !existingNotification; // This will keep the type if existingNotification is found
      });
      if (this.notificationTypes.length > 0) {
        const notifyType = this.notificationTypes[0];
        this.selectedNotificationId = notifyType.notificationTypeId;
        let patchedForm: any = {
          notificationType: this.selectedNotificationId,
          notificationMethods: {
            email: notifyType.defaultEmailBody ? true : false,
            sms: notifyType.defaultSMSText ? true : false,
          }
        };

        patchedForm.emailSubject = notifyType.defaultEmailSubject;
        patchedForm.emailBody = notifyType.defaultEmailBody;
        patchedForm.smsText = notifyType.defaultSMSText;

        this.notificationForm.patchValue(patchedForm);
        this.tagLegendTable = this.getTagLedgendTable(notifyType.tagLegend);
        this.onCheckboxChange("email");
        this.onCheckboxChange("sms");

        const notificationType = this.notificationForm.get('notificationType');
        notificationType.enable();

        //this.notificationForm.get('emailSubject').setValue('');
        //this.notificationForm.get('emailBody').setValue('');
        //this.notificationForm.get('smsText').setValue('');
      }
    }
  }
  public onNotificationTypeChange(e: any) {
    const notificationType = this.notificationForm.get('notificationType');
    const id = notificationType.value;
    const existingNotification = this.notificationSaleAdminRecords?.find(n => n.notificationTypeId === id);
    const selectednotifyType = this.notificationTypes?.filter(x => x.notificationTypeId == id)[0];
    if (existingNotification != null ) {
      const notifyType = existingNotification;
      this.selectedNotificationId = notifyType?.notificationTypeId;
      let patchedForm: any = {
        notificationType: this.selectedNotificationId,
        notificationMethods: {
          email: notifyType?.isEmail ? true : false,
          sms: notifyType?.isSMS ? true : false,
        }
      }
      patchedForm.emailSubject = notifyType?.emailSubject;
      patchedForm.emailBody = notifyType?.emailBody;
      patchedForm.smsText = notifyType?.smsMessage;

      this.notificationForm.patchValue(patchedForm);
      this.tagLegendTable = this.getTagLedgendTable(selectednotifyType.tagLegend);
      this.onCheckboxChange("email");
      this.onCheckboxChange("sms");

      const notificationType = this.notificationForm.get('notificationType');
      notificationType.enable();
    }
    else if (this.notificationTypes.length > 0) {
      const notifyType = selectednotifyType;
      this.selectedNotificationId = notifyType?.notificationTypeId;
      let patchedForm: any = {
        notificationType: this.selectedNotificationId,
        notificationMethods: {
          email: notifyType?.defaultEmailBody ? true : false,
          sms: notifyType?.defaultSMSText ? true : false,
        }
      };

      patchedForm.emailSubject = notifyType?.defaultEmailSubject;
      patchedForm.emailBody = notifyType?.defaultEmailBody;
      patchedForm.smsText = notifyType?.defaultSMSText;

      this.notificationForm.patchValue(patchedForm);
      this.tagLegendTable = this.getTagLedgendTable(notifyType.tagLegend);
      this.onCheckboxChange("email");
      this.onCheckboxChange("sms");

      const notificationType = this.notificationForm.get('notificationType');
      notificationType.enable();
    }
  }
  public getNotificationSaleAdminRecords(): void {
    this.isLoading = true;
    this.notificationsService.getSaleAdminNotification().pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {      
      this.notificationSaleAdminRecords = response;
      this.isLoading = false;
    });
  }

  public getNotificationTypes(callback:any = null): void {
    this.notificationsService.getNotificationTypes().pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.notificationTypes = response;
      this.allNotificationTypes = response;
      if (callback && typeof (callback) === "function") {
        callback(response);
      }
    });
  }
  public getTagLedgendTable(tagLegend: string[]): string {
    if (!tagLegend) { return ""; }
    let tableHTML = '<table style="margin:6px 12px">';

    // Group the tagLegend into pairs
    for (let i = 0; i < tagLegend?.length; i += 2) {
      tableHTML += '<tr>';
      tableHTML += `<td${i === 0 ? ' style="width:120px"' : ''}>${tagLegend[i]}</td>`;
      if (tagLegend[i + 1]) {
        tableHTML += `<td>${tagLegend[i + 1]}</td>`;
      }
      tableHTML += '</tr>';
    }
    tableHTML += '</table>';
    return tableHTML;
  }

  public ngOnInit(): void {

    this.initiateForm();
    this.getNotificationSaleAdminRecords();
    this.getNotificationTypes((response: any) => {
      if (this.data?.tab == this.notificationSaleAdminTabs.ADD) {
        this.onChangeView(this.notificationSaleAdminTabs.ADD, this.data?.notificationSaleAdminRow);
      }
    });

   
  }
}
